export const API_URL = process.env.API_URL || 'http://localhost:3000/api'

export const GLOBALS = {
  roles: {
    admin: {
      id: 'S',
      name: 'Administrador',
    },
    teacher: {
      id: 'T',
      name: 'Profesor',
    },
    student: {
      id: 'U',
      name: 'Estudiante',
    },
  },
  menu: {
    dashboard: {
      link: '/',
      title: 'Inicio',
      icon: 'pi pi-fw pi-home',
    },
    users: {
      link: '/user',
      linkList: '/users',
      title: 'Usuarios',
      icon: 'pi pi-user',
    },
    programs: {
      link: '/program',
      linkList: '/programs',
      viewprogram: '/viewprogram',
      title: 'Programas',
      icon: 'pi pi-folder',
    },
    profile: {
      link: '/profile',
      title: 'Mi Cuenta',
      icon: 'pi pi-user',
    },
    pods: {
      link: '/pod',
      linkList: '/pods',
      title: 'Pods',
      icon: 'pi pi-sitemap',
      viewpod: '/viewpod',
    },
    courses: {
      link: '/course',
      linkList: '/courses',
      title: 'Cursos',
      icon: 'pi pi-file',
      viewcourse: '/viewcourse',
      uses: '/uses',
      studentUses: '/student',
    },
    laboratories: {
      link: '/laboratory',
      linkList: '/laboratories',
      title: 'Laboratorios',
      icon: 'pi pi-cloud',
      viewlaboratory: '/viewlaboratory',
    },
    scheduler: {
      link: '/scheduler',
      linkList: '/schedulers',
      title: 'Scheduler',
      icon: 'pi pi-calendar',
    },
    reserve: {
      link: '/reserve',
      linkList: '/reserves',
      title: 'Mis reservas',
      icon: 'pi pi-calendar',
    },
    remoteresource: {
      link: '/remoteresource',
      linkList: '/remoteresources',
      title: 'Recurso remoto',
      icon: 'pi pi-angle-right',
      viewremoteresource: '/viewremoteresource',
    },
    successviewLab: {
      link: '/successviewLab',
      linkList: '/successviewLab',
      title: 'Succes View',
      icon: 'pi pi-success',
    },
  },
  virtual_machine: {
    types: {
      W: {
        id: 'W',
        name: 'Windows',
        icon: '',
      },
      L: {
        id: 'L',
        name: 'Linux',
      },

      N: {
        id: 'N',
        name: 'Networking',
      },
      T: {
        id: 'T',
        name: 'IOT',
      },
      O: {
        id: 'O',
        name: 'Otro',
      },
    },
    connectionType: {
      R: {
        id: 'R',
        name: 'Remote access desktop',
        icon: '',
        type: 'rdp',
      },
      S: {
        id: 'S',
        name: 'SSH',
        type: 'ssh',
      },
      T: {
        id: 'T',
        name: 'Telnet',
        type: 'telnet',
      },
      V: {
        id: 'V',
        name: 'VNC',
        type: 'vnc',
      },
    },
  },
  rdp_status: {
    connecting: 1,
    connected: 2,
    disconnected: 3,
  },
}
